import ArrowRight from 'lucide-react/dist/esm/icons/arrow-right.mjs'
import Building2 from 'lucide-react/dist/esm/icons/building-2.mjs'
import CloudDownload from 'lucide-react/dist/esm/icons/cloud-download.mjs'
import ShieldCheck from 'lucide-react/dist/esm/icons/shield-check.mjs'
import Users from 'lucide-react/dist/esm/icons/users.mjs'
import { Logo } from '../components/Logo'
import { Link } from '../routing/Router'

const miniServices: Array<[string, string, string, string]> = [
  ['Электроэнергия', '2 140 ₽', 'Оплачено 10.07', 'До 10.08'],
  ['Холодная вода', '860 ₽', 'Оплачено 10.07', 'До 10.08'],
  ['Отопление', '1 320 ₽', 'Оплачено 10.07', 'До 10.08'],
  ['Интернет', '1 750 ₽', 'Оплачено 10.07', 'Просрочено'],
]

function ProductPreview() {
  return (
    <div className="hero-product" aria-label="Предварительный вид кабинета Комонтроля">
      <div className="hero-product-sidebar">
        <Logo />
        {['Обзор', 'Объекты', 'Поставщики', 'Квитанции', 'Семья', 'Платежи', 'Настройки'].map((item, index) => (
          <span key={item} className={index === 0 ? 'active' : ''}>{item}</span>
        ))}
      </div>
      <div className="hero-product-main">
        <div className="hero-product-heading">
          <div><strong>Коммунальные платежи</strong><small>Все объекты и начисления в одном месте</small></div>
          <span>Август 2026⌄</span>
        </div>
        <div className="hero-total"><span>К оплате</span><strong>8 420 ₽</strong></div>
        <div className="mini-table">
          <div className="mini-table-head"><span>Объект / Услуга</span>{miniServices.map((service) => <span key={service[0]}>{service[0]}</span>)}</div>
          {['Квартира на Тверской', 'Дом в Балашихе'].map((property, propertyIndex) => (
            <div className="mini-property" key={property}>
              <strong>⌄ {property}</strong>
              <div className="mini-row"><span>Начислено</span>{miniServices.map((service) => <span key={service[0]}>{propertyIndex ? service[1].replace('860', '850') : service[1]}</span>)}</div>
              <div className="mini-row paid"><span>Оплачено</span>{miniServices.map((service) => <span key={service[0]}>{service[2]}</span>)}</div>
              <div className="mini-row due"><span>К оплате</span>{miniServices.map((service) => <span key={service[0]}>{service[3]}</span>)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export function LandingPage() {
  return (
    <div className="landing">
      <header className="landing-header">
        <Logo />
        <nav aria-label="Навигация по странице">
          <a href="#features">Возможности</a>
          <a href="#security">Безопасность</a>
          <a href="#how">Как работает</a>
          <Link to="/login">Войти</Link>
        </nav>
        <Link className="button button-outline" to="/login">Создать кабинет</Link>
      </header>

      <main>
        <section className="hero">
          <div className="hero-copy">
            <h1>Коммунальные<br />платежи под вашим<br />контролем</h1>
            <p>Квитанции, сроки, показания и оплата по всем объектам — в одном независимом сервисе.</p>
            <div className="hero-actions">
              <Link className="button button-primary" to="/login">Создать кабинет</Link>
              <a className="button button-outline" href="#how">Посмотреть, как работает</a>
            </div>
            <div className="trust-lines">
              <span><ShieldCheck size={21} />Не является государственным сервисом</span>
              <span><ShieldCheck size={21} />Не продаём данные и не используем рекламные трекеры.<br />Обмен — только для выбранной вами функции.</span>
            </div>
            <div className="hero-proof" id="features">
              <span><Building2 size={25} /><b>Несколько объектов</b><small>Все объекты и платежи<br />в одном кабинете</small></span>
              <span><Users size={25} /><b>Семейный доступ</b><small>Приглашайте близких<br />и управляйте правами</small></span>
              <span><CloudDownload size={25} /><b>Автозагрузка<br />по согласию</b><small>Квитанции загружаются<br />с согласия пользователя</small></span>
            </div>
          </div>
          <ProductPreview />
        </section>

        <section className="privacy-section" id="security">
          <h2>Данные работают на вас, а не на рекламу</h2>
          <div className="privacy-flow">
            <div><span>01</span><h3>Храним в России</h3><p>Первичная база и зашифрованные документы находятся на российском сервере.</p></div>
            <div><span>02</span><h3>Запрашиваем минимум</h3><p>Каждая интеграция получает только данные, необходимые для выбранного действия.</p></div>
            <div><span>03</span><h3>Вы управляете доступом</h3><p>Права задаются отдельно для каждого человека и объекта недвижимости.</p></div>
          </div>
        </section>

        <section className="how-section" id="how">
          <div><h2>От квитанции до оплаты — без ручной сверки</h2><p>Добавьте объект вручную или из квитанции. Комонтроль соберёт начисления по месяцам, напомнит о сроке и подготовит безопасное действие.</p></div>
          <ol>
            <li><strong>Добавьте объект</strong><span>Адрес, лицевые счета и поставщики</span></li>
            <li><strong>Получайте квитанции</strong><span>Файл или персональный email</span></li>
            <li><strong>Подтвердите и оплатите</strong><span>Показания, лимиты и свои автоплатежи</span></li>
          </ol>
        </section>
      </main>

      <footer className="landing-footer">
        <Logo />
        <span>Негосударственный сервис личного контроля ЖКУ</span>
        <Link to="/login">Войти <ArrowRight size={16} /></Link>
      </footer>
    </div>
  )
}
